import { Button } from '@mui/material';
import { useCallback, useState } from 'react';
import { SaveFiltersDialog } from './SaveFiltersDialog';
import { useTranslate } from 'ra-core';

function SaveFiltersButton() {
  const [open, setOpen] = useState(false);
  const translate = useTranslate();

  const onClose = useCallback(() => {
    setOpen(false);
  }, []);

  const openDialog = useCallback(() => {
    setOpen(true);
  }, []);

  return (
    <>
      <Button sx={{ height: '36px' }} variant="contained" onClick={openDialog}>
        {translate('ra.action.save_filter')}
      </Button>
      <SaveFiltersDialog open={open} onClose={onClose} />
    </>
  );
}

export { SaveFiltersButton };
